// import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { BusyModule } from 'angular2-busy';
//import { ClipboardModule } from 'ngx-clipboard';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'angular2-perfect-scrollbar';
import { VirtualScrollModule } from 'angular2-virtual-scroll';
import { Ng2MapModule } from 'ng2-map';
import { TranslateModule, TranslateService } from 'ng2-translate';
// import { EmailControlComponent } from './sharepromotionalcode/email/email-control/email-control.component';
import { ShareButtonsModule } from 'ngx-sharebuttons';
import { AuthGuard } from '../sharedcomponents/_common/auth.guard';
import { AppSettings } from '../sharedcomponents/_common/constants/app.constants';
import { countrylist } from '../sharedcomponents/_common/countrylist/countrylist.component';
import { StatelistComponent } from '../sharedcomponents/_common/countrylist/statelist.component';
import { CitylistComponent } from '../sharedcomponents/_common/countrylist/citylist.component';
import { GoogleAutocompleteComponent } from '../sharedcomponents/_common/countrylist/google-autocomplete/google-autocomplete.component';

import { SplashscreenComponent } from '../sharedcomponents/_common/splashscreen/splashscreen.component';
import { AlertService } from './commonservice/alert.service';
import { UserLanguageService } from './commonservice/commonlangservice.service';
import { CountryService } from './commonservice/countrylist.service';
import { utilityService } from './commonservice/utility.service';
import { IcecommonpagesComponent } from './icecommonpages/icecommonpages.component';
import { MapComponent } from './map-component/map.component';
import { MessageDetailComponent } from './messagecenter/message-detail/message-detail.component';
import { MessagelistComponent } from './messagecenter/messagelist/messagelist.component';
import { EmailListComponent } from './sharepromotionalcode/email/email-list/email-list.component';
import { SharepromotionalcodeComponent } from './sharepromotionalcode/sharepromotionalcode.component';
import { PageNotFoundComponent } from './_common/page-not-found/page-not-found.component';
import { AlertPopupComponent } from './_directive/alert-popup/alert-popup.component';
import { AlertComponent } from './_directive/alert.component';
import { InputAutoFocusDirective } from './_directive/Autofocus/input-auto-focus.directive';
import { EqualValidator } from './_directive/equal-validator.directive';
import { AgeValidator } from './_directive/age-validator.directive';
import { ErrorPopupComponent } from './_directive/error-popup/error-popup.component';
import { FooterComponent } from './_directive/footer/footer.component';
import { headerMenuComponent } from './_directive/headermenu/headermenu.component';
import { InfoPopupComponent } from './_directive/info-popup/info-popup.component';
import { NumberOnlyDirective } from './_directive/NumericalTextBox/NumberTextBox';
import { AddressValidatorDirective } from './_directive/AddressValidator/AddressValidatorDirective';
import { countrycodetoname } from './_pipe/country';
import { AmountFormat, MyCurrencyPipe,MyCurrencyExchangeRatePipe } from './_pipe/mycurreny';
import { NotaNumber } from './_pipe/NotANumber';
import { PaymentStatusPipe } from './_pipe/PaymentType';
import { PickupTypePipe } from './_pipe/pickuptype';
import { RoundPipe, TitleCasePipe } from './_pipe/round';
// import { ShareModule } from '@ngx-share/core';
import { SafePipe } from './_pipe/safe';
import { NumberMaskPipe } from './_pipe/ssnMasking';
import { statecodetoname } from './_pipe/state';
import { TransStatusPipe, LinkifyPipe } from './_pipe/TranscationStatus';
// import {GoogleAnalyticsEventsService} from './CommonService/googleAnalytics/google-analytics-events-service.service';
import { UniquePipe } from './_pipe/unique';
import { Ng4GeoautocompleteModule } from 'ng4-geoautocomplete';
const PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

const routes: Routes = [
  { path: 'splashscreen', component: SplashscreenComponent },
  { path: 'AboutUs', component: IcecommonpagesComponent },
  { path: 'HowToUpload', component: IcecommonpagesComponent },
  { path: 'Privacy', component: IcecommonpagesComponent },
  { path: 'ReferralProgram', component: IcecommonpagesComponent },
  { path: 'RestrictionApplied', component: IcecommonpagesComponent },
  { path: 'TermAndConditions', component: IcecommonpagesComponent }
];
@NgModule({
  imports: [
    PerfectScrollbarModule.forRoot(PERFECT_SCROLLBAR_CONFIG),
    RouterModule.forChild(routes),
    TranslateModule,
    CommonModule,
    BusyModule,
    FormsModule,
    Ng2MapModule.forRoot({ apiUrl: AppSettings.mapurl }),
    ShareButtonsModule.forRoot(),
    VirtualScrollModule,
    Ng4GeoautocompleteModule.forRoot()
    // ClipboardModule
    // ShareModule.forRoot()
  ],
  exports: [
    AlertPopupComponent,
    InfoPopupComponent,
    ErrorPopupComponent,
    EqualValidator,
    AgeValidator,
    NumberOnlyDirective,
    AddressValidatorDirective,
    headerMenuComponent,
    AlertComponent,
    UniquePipe,
    TransStatusPipe,
    LinkifyPipe,
    PaymentStatusPipe,
    PickupTypePipe,
    RoundPipe,
    TitleCasePipe,
    MyCurrencyPipe,
    MyCurrencyExchangeRatePipe,
    NotaNumber,
    AmountFormat,
    countrycodetoname,
    statecodetoname,
    NumberMaskPipe,
    SplashscreenComponent,
    countrylist,
    StatelistComponent,
    CitylistComponent,
    GoogleAutocompleteComponent,
    MapComponent,
    SharepromotionalcodeComponent,
    EmailListComponent,

    MessagelistComponent,
    MessageDetailComponent,
    IcecommonpagesComponent,
    SafePipe,
    InputAutoFocusDirective
  ],
  declarations: [
    AlertPopupComponent,
    InfoPopupComponent,
    ErrorPopupComponent,
    EqualValidator,
    AgeValidator,
    NumberOnlyDirective,
    AddressValidatorDirective,
    headerMenuComponent,
    AlertComponent,
    UniquePipe,
    TransStatusPipe,
    LinkifyPipe,
    PaymentStatusPipe,
    PickupTypePipe,
    RoundPipe,
    TitleCasePipe,
    MyCurrencyPipe,
    MyCurrencyExchangeRatePipe,
    NotaNumber,
    AmountFormat,
    countrycodetoname,
    statecodetoname,
    NumberMaskPipe,
    SplashscreenComponent,
    countrylist,
    StatelistComponent,
    CitylistComponent,
    GoogleAutocompleteComponent,
    MapComponent,
    SharepromotionalcodeComponent,
    EmailListComponent,
    InputAutoFocusDirective,
    PageNotFoundComponent,
    FooterComponent,
    MessagelistComponent,
    MessageDetailComponent,
    IcecommonpagesComponent,
    SafePipe
  ],
  entryComponents: [
    AlertPopupComponent,
    InfoPopupComponent,
    ErrorPopupComponent,
    countrylist,
    StatelistComponent,
    CitylistComponent,
    MessageDetailComponent,
    EmailListComponent,
    GoogleAutocompleteComponent
  ],
  providers: [utilityService, AuthGuard, AlertService, UserLanguageService, CountryService, TranslateService]
})
export class sharedModule {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/shared-routing.module.ts